exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-navbar ul li{color:#888;font-weight:400!important}.user-navbar ul li .active,.user-navbar ul li:hover{font-weight:300!important}", ""]);

// exports
